import { render, staticRenderFns } from "./modalSelectTest.vue?vue&type=template&id=6272e13d&scoped=true"
import script from "./modalSelectTest.vue?vue&type=script&lang=js"
export * from "./modalSelectTest.vue?vue&type=script&lang=js"
import style0 from "./modalSelectTest.vue?vue&type=style&index=0&id=6272e13d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6272e13d",
  null
  
)

export default component.exports